/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import { motion } from 'framer-motion'
import React,{useState,useCallback} from 'react'
import AppliedOfferToolTip from '../../Components/AppliedOfferToolTip/Index'
import { AccessPrevilegesFunction } from '../../constants/globalPrivilegesFunction';


const options = ["xs", "s", "m", "l", "xl", "xxl", "xxxl"];

export default function CartSummary({
    Summary,
    prod,
    items,
    orderFlow,
    handleFlow,
    OrderType,
    setOrderType,
    ErrorID,
    isTradeEUB,
    Privilages,
    disabledTradeEUB,
    specialcondition
}) {
   
    const [appliedOfferHover, setappliedOfferHover] = useState('')
    const cureentTypes=[]
    const { SUPPORTS, PRIVILAGES } = JSON.parse(localStorage.getItem('user')).profile
    if(PRIVILAGES.includes('place_trade_order')){
        cureentTypes.push({
            value:'Trade Order'
        })
    }
    if(PRIVILAGES.includes('place_eub_order')){
        cureentTypes.push({
            value:'Trade EUB Order'
        })
    }
    const [types, setTypes] = useState(cureentTypes)
    const uniqueCategories = [...new Set((items?.items || []).map(item => item.MAIN_CATEGORY).filter(Boolean))]
    const hasMultipleCategories = uniqueCategories.length > 1
    let rsmExist = []
    if (SUPPORTS !== undefined && SUPPORTS.length > 0)
        rsmExist = SUPPORTS.filter( x => x.ROLES === 'regional_sales_manager' || x.roles === 'regional_sales_manager' )
    return (
        <motion.div
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: -20 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ ease: 'easeOut', duration: 1 }} className="lg:w-[30%] w-full lg:mt-0 mt-4 lg:ml-[26px]">
            <div className="border border-[#CBC7C7] p-4 rounded-md bg-[#F5F5FA]">
                <div className="flex justify-between items-center">
                    <p className="sm:text-lg text-base font-semibold text-[#090406]">Order Summary</p>
                    <p className="text-xs3 font-semibold text-[#555259] " style={{maxWidth:'500px',flexWrap:'wrap'}}>Total Order Qty.: 
                        {Object.keys(items?.summary?.quantity).length>0 && Object.keys(items?.summary?.quantity).map((UOM,i)=>(
                            <span style={{float: `${i===0?'':'right'}`}} key={UOM} className={`font-semibold`}>{Number(items?.summary?.quantity[UOM])} {UOM} <br/></span>
                        ))}</p>
                </div>
                <div className="flex justify-between items-center mt-2">
                    <p className="sm:pl-2.5 sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                    <p className="sm:text-lg text-base font-semibold text-[#555259]">{Summary?.order_value.toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    })} </p>
                </div>
                <div className="flex justify-between items-center border-b bordder-[#CBCBCB] sm:pb-1 py-2">
                    <p className="sm:pl-2.5 sm:text-xs18 text-sm text-[#555259] font-normal flex items-center">
                        Discount
                        <span className="ml-1 relative">
                            <button 
                                onMouseEnter={()=>{
                                    setTimeout(() => {
                                        setappliedOfferHover('active')
                                    }, 1000);
                                }} onMouseLeave={()=>{
                                    setTimeout(() => {
                                        setappliedOfferHover('')
                                    }, 2000);
                                }}
                                data-tooltip-target="tooltip-discountPercentage1" data-tooltip-placement="right" data-tooltip-trigger="click" type="button">
                                <img src="images/info-filled_icon.svg" alt="icon" className="cursor-pointer"/>
                            </button>
                            {appliedOfferHover !=='' &&(
                                <AppliedOfferToolTip hover={appliedOfferHover !==''} prod={Summary}/>
                            )}
                        </span>
                    </p>
                    <p className="sm:text-lg text-base font-semibold text-[#555259]">- {Number(Summary?.total_discount).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    })||0.00}</p>
                </div>
                <div className={`flex justify-between items-center pt-1 ${OrderType?'border-b border-[#CBCBCB] sm:pb-1 py-2':''}`}>
                    <p className="sm:pl-2.5 sm:text-xs7 text-sm text-[#000000] font-normal">
                        Net Amount
                    </p>
                    <p className="sm:text-lg text-base font-semibold text-[#000000]">{Number(Summary?.net_amount).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    })||0.00}</p>
                </div>
                <div className={`${OrderType?'mt-3':'mt-6'}`}>
                    {!OrderType &&<button
                        disabled={ErrorID!=='' || SUPPORTS=== undefined || SUPPORTS.length === 0 || rsmExist.length === 0 || hasMultipleCategories}
                        onClick={()=>setOrderType(!OrderType)}
                        type="button" className={`w-full sm:py-4 py-2 rounded-lg
                        ${(ErrorID!=='' || SUPPORTS=== undefined || SUPPORTS.length === 0 || hasMultipleCategories)?'bg-[#A5A5A5] pointer-events-none':'bg-[#555259] cursor-pointer'} sm:text-lg text-base font-semibold text-[#FFFFFF]`}>
                        Select Order Type
                    </button>}
                    {(SUPPORTS=== undefined || SUPPORTS.length === 0 || rsmExist.length === 0) && <p className="sm:text-lg text-base font-semibold text-[red] sm:pt-3 pt-2">Please contact admin to add Ador support team</p>}
                    {!OrderType && hasMultipleCategories && (
                        <div className="mt-3 rounded-md bg-[#F2DEDE] px-3 py-2">
                            <p className="text-sm text-[#ED1C24]">
                                Your cart contains products from multiple categories:
                            </p>
                            <p className="text-sm text-[#ED1C24] font-bold">
                                {uniqueCategories.join(', ')}.
                            </p>
                            <p className="text-sm font-normal text-[#ED1C24] mt-1">
                                Each category must be placed as a separate order. Please keep items from only one category and remove the others to proceed.
                            </p>
                        </div>
                    )}
                    {OrderType && !orderFlow.selectAddressClicked &&(
                        <motion.div
                            animate={{ opacity: 1, y: 0 }}
                            initial={{ opacity: 0, y: -20 }}
                            exit={{ opacity: 0, y: 20 }}
                            transition={{ ease: 'easeOut', duration: 1 }}
                            key={OrderType}
                            style={{pointerEvents:`${ErrorID===''?'':'none'}`}}>
                            <p className="sm:text-lg text-base font-semibold text-[#090406] sm:pt-3 pt-2">Select Order Type</p>
                            {isTradeEUB ? types.map((val,i)=>(
                                <div className={`${i === 0 ? 'mt-3' : 'mt-2'}`} key={val.value}>
                                    <div className={`relative checkbox custom-checkbox ${(val.value === "Trade EUB Order" && disabledTradeEUB.every(value => !value)) && specialcondition.every((value => value=== 'Special')) ? 'disable-radio2' : 'custom-radio2'} flex items-center`}>
                                        <input
                                            disabled={val.value === "Trade EUB Order" && disabledTradeEUB.every(value => !value) && specialcondition.every((value => value=== 'Special' || value=== 'Special Recurring'))}
                                            type="radio"
                                            id={`checkbox-${i}`}
                                            onChange={() => handleFlow('order_type', val.value)}
                                            name={`radiodate-${i}`}
                                            className={`${(val.value === "Trade EUB Order" && disabledTradeEUB.every(value => !value)) && specialcondition.every((value => value=== 'Special' || value=== 'Special Recurring')) ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                            checked={orderFlow.order_type === val.value}
                                        />
                                        <label
                                            disabled={val.value === "Trade EUB Order" && disabledTradeEUB.every(value => !value)}
                                            htmlFor={`checkbox-${i}`}
                                            className={`${(val.value === "Trade EUB Order" && disabledTradeEUB.every(value => !value)) && specialcondition.every((value => value=== 'Special' || value=== 'Special Recurring')) ? 'cursor-not-allowed text-[#cac9cb]' : 'cursor-pointer text-[#555259]'} text-sm font-normal pl-[25px] mt-[3px]`}
                                        >
                                            {val.value}
                                        </label>
                                    </div>
                                </div>
                           
                            )): (                              
                                <div className="mt-3">
                                    <div className="relative checkbox custom-checkbox custom-radio2 flex items-center">
                                        <input type="radio" id={`checkbox-${0}`} onChange={()=>handleFlow('order_type','Trade Order')} name="radiodate-0" className="cursor-pointer" checked={orderFlow.order_type==='Trade Order'} />
                                        <label htmlFor={`checkbox-${0}`} className="text-sm font-normal text-[#555259] pl-[25px] cursor-pointer mt-[3px]">Trade Order</label>
                                    </div>
                                </div>
                            )}
                            {types.length === 0 && <p className='text-[#ED1C24]'>Please contact Ador support for placing an Order</p> }
                            {types.length === 1 && types[0].value === 'Trade Order' && disabledTradeEUB.every(value => value) && specialcondition.every((value => value === 'Special')) && <p className='sm:text-lg text-base font-semibold text-[#ff0000] sm:pt-3 pt-2'>Trade EUB is not applicable, Please contact Ador support</p>}
                            <div className="mt-6">
                                {/* <!-- for active bg-[#555259] --> */}
                                <button
                                    disabled={orderFlow.order_type==='' || ErrorID!=='' || hasMultipleCategories}
                                    onClick={()=>handleFlow('selectAddressClicked',true)}
                                    type="button" className={`w-full sm:py-4 py-2 rounded-lg ${orderFlow.order_type==='' || ErrorID!=='' || hasMultipleCategories ?'bg-[#A5A5A5] pointer-events-none':'bg-[#555259] cursor-pointer'} sm:text-lg text-base font-semibold text-[#FFFFFF]`}>
                                    Select Address
                                </button>
                            </div>
                        </motion.div>
                    )}
                    {OrderType && orderFlow.selectAddressClicked &&(
                        <motion.div
                            animate={{ opacity: 1, y: 0 }}
                            initial={{ opacity: 0, y: -20 }}
                            exit={{ opacity: 0, y: 20 }}
                            transition={{ ease: 'easeOut', duration: 1 }}
                            key={orderFlow.selectAddressClicked} >
                            <p className="text-sm font-semibold text-[#090406] pt-2">Order Type</p>
                            <p className='sm:text-lg text-base font-normal text-[#555259]'>{orderFlow.order_type}</p>
                            
                            <div className="mt-6">
                                {/* <!-- for active bg-[#555259] --> */}
                                <button
                                    onClick={()=>handleFlow('viewFinancialSummary',true)} 
                                    type="button" className={`w-full sm:py-4 py-2 rounded-lg ${orderFlow.order_type===''?'bg-[#A5A5A5] pointer-events-none':'bg-[#555259] cursor-pointer'} sm:text-lg text-base font-semibold text-[#FFFFFF]`}>
                                    View Final Summary
                                </button>
                            </div>
                        </motion.div>
                    )}
                </div>
                    
            </div>
        </motion.div>
    )
}
